module.exports = {
          srcSet: __webpack_public_path__ + "public/images/c1a2a8585d98a18538911e148dfc548d-414.jpg"+" 414w",
          images:[ {path: __webpack_public_path__ + "public/images/c1a2a8585d98a18538911e148dfc548d-414.jpg",width: 414,height: 850}],
          src: __webpack_public_path__ + "public/images/c1a2a8585d98a18538911e148dfc548d-414.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/c1a2a8585d98a18538911e148dfc548d-414.jpg"},
          
          width: 414,
          height: 850
        }